import { memo } from 'react';

import { LED_MIRRORS_VALUE } from '@shared/constants/catalog';
import { ProductCardType } from '@shared/types/product';
import { VStack } from '@shared/ui/Stack';
import { formatPrice } from '@shared/utils/formatPrice/formatPrice';
import { YandexSplitBadge } from '@widgets/ProductCard/ui/CardVariant/YandexSplitBadge/YandexSplitBadge';
import { ProductReviewsSummary } from '@widgets/ProductReviewsSummary';

import cls from './Info.module.scss';

type InfoProps = Pick<
  ProductCardType,
  'name' | 'price' | 'width' | 'height' | 'depth' | 'subCategory' | 'backlightType' | 'rating'
>;

export const Info = memo<InfoProps>(({ name, height, depth, width, price, subCategory, backlightType, rating }) => {
  const isLedMirror = subCategory === LED_MIRRORS_VALUE;

  return (
    <div className={cls.wrap}>
      <YandexSplitBadge {...{ price }} />
      {formatPrice(price) && <div className={cls.price}>{formatPrice(price)}</div>}

      <ProductReviewsSummary
        className={cls.reviewsSummary}
        rating={rating}
      />
      <div className={cls.name}>{name}</div>
      <VStack className={cls.info}>
        {width && (
          <div className={cls.size}>
            Ширина: <span>{width.value}</span> см
          </div>
        )}

        {height && (
          <div className={cls.size}>
            Высота: <span>{height.value}</span> см
          </div>
        )}

        {depth && !isLedMirror && (
          <div className={cls.size}>
            Глубина: <span>{depth.value}</span> см
          </div>
        )}

        {backlightType && (
          <div className={cls.backlightType}>
            Тип подсветки: <span>{backlightType}</span>
          </div>
        )}
      </VStack>
    </div>
  );
});
